<template>

  <div class="workspace">
    <div class="section-heading">
      <h2>Product Editor</h2>
    </div>
    <div class="flex-area">
      <div class="dash-nav">
        <div class="tab" :class="[activeTab === 0 ? 'active' : '']" @click="activeTab = 0">Product List</div>
        <div class="tab" :class="[activeTab === 1 ? 'active' : '']" @click="activeTab = 1">Create Product</div>
        <div class="tab" :class="[activeTab === 2 ? 'active' : '']" @click="activeTab = 2">Create Features</div>
      </div>
<div class="w-full" v-if="activeTab === 0">
      <product-list />
    </div>

    <div class="w-full" v-if="activeTab === 1">
      <create-bundle ref="bundle"/>
    </div>

    <div class="w-full" v-if="activeTab === 2">
      <manage-services />
    </div>

    </div>
  </div>
</template>
<script>
import ProductList from './components/ProductList'
import CreateBundle from './components/CreateBundle'
import ManageServices from './components/ManageServices'
export default {
  components: {
    CreateBundle,
    ManageServices,
    ProductList
  },
  data () {
    return {
      create: true,
      activeTab: 0
    }
  },
  beforeMount () {
    console.log('aktif user', this.activeUserInfo)
    if (this.activeUserInfo.permissionLevel !== 2048) {
      this.$router.push({name: 'page-error-404'})
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {

    editProduct (product) {
      this.activeTab = 1
      setTimeout(() => {
        this.$refs.bundle.editBundle(product)
      }, 500)
    }
  },
  watch: {
  },
  metaInfo () {
    return {
      title: 'Product Editor',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Manage your company products'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
.product-create-form {
  width:100%;
}
.pcf-divider {
  width:100%;
  border:1px solid #000;
  margin:10px 0;
}
.pcf-feature-area {
  width:100%;
  display:flex;
  flex-wrap: wrap;
  justify-content: flex-start;

}
.pcf-feature {
  display:flex;
  width:100px;
  height: 100px;
  border-radius: 7px;
  border:2px solid #ccc;
  background-color:#fff;
  color:#000;
  align-items: center;
  justify-content: center;
  margin:10px;
  text-align: center;
  padding:10px;
  font-size:14px;
  cursor:pointer;
  transition:all .2s ease;
  font-weight: 600;
}
.pcf-add-feature {
  font-size:44px;
  font-weight: 600;
}
.pcf-feature:hover {
  transform:translateY(-5px);
}
.pcf-price-edit-area {
  margin:20px 0;
  width:50%;
}
.pcf-price-item {
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  color:#000;
  font-weight: 600;
  padding:10px;
}
.pcf-price-item:nth-child(odd){
  background-color:#f5f5f5;
}
.pcf-price-total {
  border-radius:7px;
  padding:10px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
  box-shadow:0px 0px 5px 3px rgba(0,0,0,.1);
  margin:20px 0;
}
.pcf-item-price input {
  width:100px;
  border:1px solid orange;
  margin:0;
  text-align:right;
  padding:5px;
}
.pcf-price-total .pcf-item-name {
  font-size:22px;
  font-weight: bold;
}
.pcf-assign {
  div{
    width:45%;
  }
  select {
    border:1px solid #ccc;
    padding:5px;
    width:100%;
  }
  margin:20px 0;
  display:flex;
  width:100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
</style>
<style lang="scss">
.ef-row{
  width:100%;
}
.edit-feature-form{
  display:flex;
  width:100%;
  justify-content: flex-start;
}
.ef-edit {
  padding-bottom:10px;
  border-bottom:1px solid #000;
}
.ef-feature{
  .edit-col:first-child{
    width:70%;
  }
  .edit-col:nth-child(2){
    width:30%;
  }
  width:100%;
  display:flex;
  flex-wrap:wrap;
  align-items:center;
}
.ef-col {
  &:first-child{
    border-right:1px solid #000;
    padding-right:20px;
  }
  &:last-child{
    padding-left:20px;
  }
width:50%;
}
.ef-input {
  border:1px solid #ccc;
  padding:5px;
  width: 100%;
}
.ef-inner-row {
  display:flex;
  justify-content: flex-start;
  margin:10px 0;
  flex-wrap: wrap;
}
.ef-row-inner-col {
  width:50%;
}
.ef-single-row .ef-row-inner-col {
width:100%;
}
.ef-label {
  font-weight:600;
}
.ef-textarea {
  resize: none;
  height:200px;
}
</style>
